export default __webpack_public_path__ + "static/media/donation.58f23959.svg";